import { render, staticRenderFns } from "./tab-plano.vue?vue&type=template&id=4f4db527&"
import script from "./tab-plano.vue?vue&type=script&lang=js&"
export * from "./tab-plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports